import $ from 'jquery';
import _ from 'underscore';
import Constants from 'root/constants';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modals from 'root/modals';
import Form from 'root/module/form';
import Util from 'root/module/util';
import View from 'view/base';
import Model_User_Segment from 'model/user_segment';

const condition_keys = {
    identification: 'User ID',
    email: 'Email',
    display_name: 'Name'
};

export const operators = {
    is: 'is',
    not: 'is not',
    contains: 'contains',
    contains_not: 'doesn\'t contain',
    starts: 'starts with',
    ends: 'ends with',
    greater: 'is greater than',
    less: 'is less than',
    regex: 'matches regex',
};

export default View.extend({
    condition_max: 10,

    segment_type: Constants.USER_SEGMENT_TYPE_AND,

    events: {
        'click .condition-add'               : 'onConditionAdd',
        'click .condition-delete'            : 'onConditionDelete',
        'click .condition-type li'           : 'onConditionTypeChange',
        'input [name="segment_name"]'        : 'onCheckForm',
        'input [name="segment_description"]' : 'onCheckForm',
        'input [name="condition_value"]'     : 'onCheckForm',
        'click .condition-key li'            : 'onCheckForm',
        'click .condition-operator li'       : 'onCheckForm',
        'click .account-upgrade'             : 'onAccountUpgrade',
        'submit form'                        : 'onSubmit'
    },

    dom_handlers: {
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },

        onConditionAdd: function(e) {
            this.renderCondition();
            this.checkForm();
        },

        onConditionDelete: function(e) {
            $(e.currentTarget).parents('.user-segment-condition').remove();
            this.checkForm();
        },

        onConditionTypeChange: function(e) {
            this.segment_type = $(e.currentTarget).data('val');
            this.$el.find('.user-segment-condition').attr('data-type', this.segment_type);
            this.checkForm();
        },

        onCheckForm: function(e) {
            // wait for dropdown to update first
            setTimeout(() => {
                this.checkForm();
            });
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));
            var condition = this.getCondition();

            if (!condition.length) {
                UI.error('Please add at least one condition.');
                return;
            }

            this.$el.find('button:submit').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: this.model.id ? 'user_segment/update' : 'user_segment/add',
                data: {
                    ...form_data,
                    id: this.model.id,
                    segment_type: this.segment_type,
                    segment_condition: condition
                },
                success: (response) => {
                    if (this.model.id) {
                        this.model.set(response);
                        UI.success('User segment updated.');
                    } else {
                        Cache.user_segment.add({...response, usage_project: 0});
                        UI.success('User segment created.');
                    }

                    this.trigger('Submit::Success');
                },
                complete: () => {
                    this.$el.find('button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        }
    },

    initialize: function() {
        if (!this.model) {
            // create new segment
            this.model = new Model_User_Segment({
                segment_condition: JSON.stringify([{
                    key: Cache.user_properties.length ? Cache.user_properties[0] : '',
                    operator: 'is',
                    value: ''
                }])
            });
        }

        this.segment_type = this.model.get('segment_type');
    },

    checkForm: function() {
        if (!Cache.account.hasFeature('user_segment')) {
            return;
        }

        // Step 1: check if form is changed
        var form_data = Form.getData(this.$el.find('form'));
        var condition = this.getCondition();

        var is_changed = false;

        if (!this.model.id) {
            // create new segment
            is_changed = true;
        } else if (form_data.segment_name !== this.model.get('segment_name')) {
            is_changed = true;
        } else if (form_data.segment_description !== this.model.get('segment_description')) {
            is_changed = true;
        } else if (this.segment_type !== this.model.get('segment_type')) {
            is_changed = true;
        } else if (JSON.stringify(condition) !== this.model.get('segment_condition')) {
            is_changed = true;
        }

        this.$el.find('button:submit').prop('disabled', !is_changed);

        // Step 2: check condition limit
        this.$el.find('.condition-add').prop('disabled', condition.length >= this.condition_max);
        this.$el.find('.condition-max-alert').toggle(condition.length >= this.condition_max);

        // Step 3: check minimum condition
        this.$el.find('.condition-delete').prop('disabled', condition.length <= 1);
    },

    // get condition from UI
    getCondition: function() {
        var condition = [];

        this.$el.find('.user-segment-condition').each((index, el) => {
            var key      = $(el).find('.condition-key li.selected').data('val');
            var operator = $(el).find('.condition-operator li.selected').data('val');
            var value    = $(el).find('input').val().trim();

            if (key && operator && value) {
                condition.push({
                    key      : key,
                    operator : operator,
                    value    : value
                });
            }
        });

        return condition;
    },

    renderCondition: function(condition) {
        var user_properties = '';
        var operator_options = '';

        Cache.user_properties.forEach((name) => {
            var name_escaped = Util.htmlEntities(name);
            user_properties += '<li data-val="' + name_escaped + '">' + name_escaped + '</li>';
        });

        Object.keys(operators).forEach((key) => {
            operator_options += '<li data-val="' + key + '">' + operators[key]+ '</li>';
        });

        var html =
        '<div class="user-segment-condition" data-type="' + this.segment_type + '">' +
            (Cache.app.isAdmin() ?
            '<div><button type="button" class="condition-delete small square round text-icon"><i class="fa-solid fa-circle-minus"></i></button></div>' : '') +
            '<div>' +
                '<div>' +
                    '<div class="condition-key button-dropdown button-dropdown-full button-dropdown-large" data-update="true">' +
                        '<button type="button" class="dropdown-select">Select...</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' +
                                // system fields
                                '<li data-val="identification">User ID</li>' +
                                '<li data-val="email">Email</li>' +
                                '<li data-val="display_name">Name</li>' +
                                // custom fields
                                user_properties +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<div class="condition-operator button-dropdown button-dropdown-full button-dropdown-large" data-update="true">' +
                        '<button type="button" class="dropdown-select">is</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' + operator_options + '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    // TODO: add support for other types of values (dropdown, date, etc.)
                    '<input type="text" name="condition_value" class="solid compact">' +
                '</div>' +
            '</div>' +
        '</div>';

        var condition_el = $(html);

        this.$el.find('.region-condition').append(condition_el);

        if (condition) {
            // key
            if (condition.key) {
                condition_el.find('.condition-key > button').text(condition_keys[condition.key] || condition.key);
                condition_el.find('.condition-key li[data-val="' + condition.key + '"]').addClass('selected');
            }

            // operator
            if (operators[condition.operator]) {
                condition_el.find('.condition-operator > button').text(operators[condition.operator]);
                condition_el.find('.condition-operator li[data-val="' + condition.operator + '"]').addClass('selected');
            }

            // value
            Form.setData(condition_el, {
                condition_value: condition.value || ''
            });
        } else {
            // operator
            condition_el.find('.condition-operator li:first').addClass('selected');
        }
    },

    render: function() {
        var content =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Name</div>' +
                '<input type="text" class="solid medium" name="segment_name" maxlength="100" placeholder="Give your segment a name" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Description</div>' +
                '<textarea type="text" class="solid compact" name="segment_description" rows="4" maxlength="1000" placeholder="Describe what this segment is for"></textarea>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Conditions</div>' +
                '<div class="margin-bottom-12">When ' +
                    '<div class="condition-type button-dropdown button-dropdown-left" data-update="true">' +
                        '<button type="button" class="dropdown-select"></button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' +
                                '<li data-val="' + Constants.USER_SEGMENT_TYPE_AND + '">All</li>' +
                                '<li data-val="' + Constants.USER_SEGMENT_TYPE_OR + '">Any</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                ' of the conditions match</div>' +
                '<div class="region-condition"></div>' +
                '<div class="condition-max-alert text-info text-medium margin-left-12" style="display:none;">You can add up to 10 conditions in one user segment</div>' +
                (Cache.app.isAdmin() ?
                '<button type="button" class="condition-add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add condition</button>' : '') +
            '</div>' +
            (Cache.app.isAdmin() ?
            '<div class="sidebar-bottom">' +
                (Cache.account.hasFeature('user_segment') ?
                '<button type="submit" class="primary">' + (this.model.id ? 'Save Changes' : 'Create Segment') + '</button>' :
                '<span class="text-info text-medium margin-right-8"><i class="fa-solid fa-circle-exclamation text-icon"></i> Upgrade your plan to unlock Segments</span>' +
                '<button type="button" class="shiny medium account-upgrade margin-right-8"><span>Upgrade</span></button>') +
            '</div>' : '') +
        '</form>';

        this.$el.html(content);

        var segment_condition = this.model.get('segment_condition');
        if (segment_condition) {
            JSON.parse(segment_condition).forEach((condition) => {
                this.renderCondition(condition);
            });
        }

        Form.setData(this.$el.find('form'), this.model.attributes);

        this.$el.find('.condition-type > button').text(this.segment_type === Constants.USER_SEGMENT_TYPE_AND ? 'All' : 'Any');
        this.$el.find('.condition-type li[data-val="' + this.segment_type + '"]').addClass('selected');

        if (this.model.id || !Cache.account.hasFeature('user_segment')) {
            this.$el.find('button:submit').prop('disabled', true);
        }

        this.checkForm();

        return this;
    }
});